import React from "react";
import { Tooltip } from "antd";
import {
  IFulfilledChat,
  IMessageInviteBody,
  IMessageTextBody
} from "interfaces/interfacesChat";
import {
  ChatItemRoot,
  Time,
  FullName,
  NotificationsBox,
  ProfilePicture,
  RightSide,
  LastMessage,
  UnreadIndicator
} from "./styles";
import { formatDateTime, parseServerDateTime } from "../../../utils/time";
import { useTranslation } from "react-i18next";

interface IChatItem {
  chat: IFulfilledChat;
  onClick: (chat: IFulfilledChat) => void;
  isSelected?: boolean;
}

export const ChatItem = React.memo<IChatItem>(
  ({ chat, isSelected = false, onClick }) => {
    let hasUnread = chat.request_user_unread_count > 0;
    const { t } = useTranslation("chats");

    const date = parseServerDateTime(chat.updated_at);

    let lastMessageText = "";
    if (chat.most_recent_msg?.deleted) {
      lastMessageText = t("textDeletedMessage");
    } else if (
      (chat.most_recent_msg?.body as IMessageInviteBody)?.invite_msg_status
    ) {
      lastMessageText = t(
        `inviteMessage.${
          (chat.most_recent_msg?.body as IMessageInviteBody)?.invite_msg_status
        }`
      );
    } else if ((chat.most_recent_msg?.body as IMessageTextBody)?.text) {
      lastMessageText = (chat.most_recent_msg?.body as IMessageTextBody)?.text;
    }

    const fullName =
      chat.conversation_partner_short?.first_name +
      " " +
      chat.conversation_partner_short?.last_name;

    return (
      <ChatItemRoot
        onClick={() => {
          onClick(chat);
        }}
        isSelected={isSelected}
      >
        <ProfilePicture src={chat.conversation_partner_short?.thumbnail_url} />
        <RightSide>
          <FullName title={fullName}>{fullName}</FullName>
          <LastMessage title={lastMessageText}>{lastMessageText}</LastMessage>
          <Time>
            {date ? formatDateTime(date, { minimizeOutputLength: true }) : null}
          </Time>
        </RightSide>
        <NotificationsBox>
          {hasUnread ? (
            <Tooltip
              placement={"bottom"}
              mouseEnterDelay={0}
              mouseLeaveDelay={0}
              destroyTooltipOnHide={true}
              title={t("unreadMessagesIconTooltip")}
            >
              <UnreadIndicator>
                {chat.request_user_unread_count}
              </UnreadIndicator>
            </Tooltip>
          ) : null}
        </NotificationsBox>
      </ChatItemRoot>
    );
  }
);
